import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutUsRoutingModule } from './about-us-routing.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ZendeskDevelopmentComponent } from './zendesk-development/zendesk-development.component';
import { IndexComponent } from './index/index.component';

@NgModule({
  imports: [
    CommonModule,
    AboutUsRoutingModule
  ],
  declarations: [PrivacyPolicyComponent, ZendeskDevelopmentComponent, IndexComponent]
})
export class AboutUsModule { }
